export const EMOJI_ELEMENT_ID_PREFIX = 'Emoji';
export const EMOJI_CHANGE_SOURCE = 'EmojiPicker';
export const EMOJI_PICKER_TRIGGER_CHARACTER = ':';
export const EMOJI_SUGGESTIONS_LABEL = 'emojiPickerSuggestions';
export const EMOJI_SUGGESTION_LABEL_PREFIX = 'emojiPickerSuggestion-';

export const MAX_RESULTS = 6;
